import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MenuItemLocal} from '../menu-item.model';
import {MenuService} from '../menu.service';
import {AsyncPipe, NgForOf, NgIf, NgStyle} from '@angular/common';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-sub-menu',
  standalone: true,
  templateUrl: './sub-menu.component.html',
  imports: [
    NgIf,
    NgForOf,
    RouterLinkActive,
    NgStyle,
    RouterLink,
    TranslateModule,
    AsyncPipe
  ],
  styleUrls: ['./sub-menu.component.scss']
})
export class SubMenuComponent implements OnInit {
  @Input() menuArray: MenuItemLocal[];
  @Input() isDesktop: boolean;
  @Input() isConfigMode: boolean;

  @Output() linkSelected = new EventEmitter();
  @Output() favoriteMenuSelected = new EventEmitter();

  constructor(private menuService: MenuService) {
  }

  public selectLink() {
    this.linkSelected.emit();

    if (!this.isDesktop) {
      this.menuService.isCollapsed.next(true);
    }
  }

  public isActiveLink(location) {
    return window.location.hash.startsWith(location);
  }

  ngOnInit() {
    return;
  }

  selectMenu(event, menu: any) {
    event.stopPropagation();
    menu.visible = !menu.visible;
    this.favoriteMenuSelected.emit();
  }

}
